var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8BurkinaFaso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7cb342",
    d: "M44,24H4c0,11.046,8.954,20,20,20S44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M24,4C12.954,4,4,12.954,4,24h40C44,12.954,35.046,4,24,4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M24,19.244l1.18,3.75H29l-3.09,2.129l1.18,3.633L24,26.51l-3.09,2.246l1.18-3.633L19,22.994h3.82 L24,19.244z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8BurkinaFaso);
export default __webpack_public_path__ + "static/media/icons8-burkina-faso.92ea8ca02acd1f009a6c304cf16281a6.svg";
export { ForwardRef as ReactComponent };